if (!('process' in window)) {
  window.process = {}
}
